import { render, staticRenderFns } from "./TopicPosts.vue?vue&type=template&id=ac99717c&scoped=true"
import script from "./TopicPosts.vue?vue&type=script&lang=js"
export * from "./TopicPosts.vue?vue&type=script&lang=js"
import style0 from "./TopicPosts.vue?vue&type=style&index=0&id=ac99717c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_prettier@2.8.8_vue-template-compiler@2.7.16_webpack@5.89.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac99717c",
  null
  
)

export default component.exports